
import RcDomainMap from "@/domain/common/RcDomainMap.js";
import Question from './Question.js';
import QuestionUtils from "./QuestionUtils.js";

export default class QuestionMap extends RcDomainMap {
  static MODEL_NAME = Question.MODEL_NAME  + "Map";
  
  constructor(domain, data) {
    super(domain, data, QuestionMap.MODEL_NAME);
  }

  find() {
    var keys = this.keys();
    var found = new QuestionMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.questions().findById(key);
      var item = new Question(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    
    return found;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getQuestion(key);
      values.push(item);
    }
    return values;
  }
  
  sortByPart() {
    return this.sort();
  }
  
  sort() {
    var sorted = [];
    sorted = this.list();
    sorted = sorted.sort(QuestionUtils.SortQuestionByPart);
    return sorted;
  }
  
  getQuestion(key) {
    var value = super.get(key);
    return new Question(this.domain, value);
  }
  
  copy() {
    var data = this._copy();
    return new QuestionMap(this.domain, data);
  }
}